import { useMemo } from 'react'
import { useDomainMessages } from 'domains/aggregate-store-performance/utils/domain/intl'
import { type GroupedFiltersDropdownOptions } from './FiltersDropdown.types'
import { MetricFilters } from './FiltersDropdown.constants'

export const useGetFilterOptions = () => {
  const messages = useDomainMessages({
    metricsGroupTitle: 'aggregateStorePerformanceDomain.filtersDropdown.metrics',
    availability: 'aggregateStorePerformanceDomain.filtersDropdown.availability',
    availabilitySubtitle: 'aggregateStorePerformanceDomain.filtersDropdown.availabilitySubtitle',
    utilization: 'aggregateStorePerformanceDomain.filtersDropdown.utilization',
    utilizationSubtitle: 'aggregateStorePerformanceDomain.filtersDropdown.utilizationSubtitle',
    matchRate: 'aggregateStorePerformanceDomain.filtersDropdown.matchRate',
    matchRateSubtitle: 'aggregateStorePerformanceDomain.filtersDropdown.matchRateSubtitle',
  })

  const filters: GroupedFiltersDropdownOptions[] = useMemo(
    () => [
      {
        label: messages.metricsGroupTitle,
        options: [
          {
            label: messages.availability,
            subtitle: messages.availabilitySubtitle,
            value: MetricFilters.Availability,
          },
          {
            label: messages.utilization,
            subtitle: messages.utilizationSubtitle,
            value: MetricFilters.Utilization,
          },
          {
            label: messages.matchRate,
            subtitle: messages.matchRateSubtitle,
            value: MetricFilters.MatchRate,
          },
        ],
      },
    ],
    [messages]
  )

  return {
    filters,
  }
}
